export const OS_FAMILY_REPORT_ID = 'os-family';
